import { render, staticRenderFns } from "./CourierIncomeTimeline.vue?vue&type=template&id=63544c08&scoped=true&"
import script from "./CourierIncomeTimeline.vue?vue&type=script&lang=js&"
export * from "./CourierIncomeTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63544c08",
  null
  
)

export default component.exports